import { find } from 'lodash';
import { updateUserInfo } from '..';
import * as actionTypes from '../../constants/actionTypes';
import { DELETE, GET, PUT } from '../../constants/requestMethods';
import { CALL_PRIVATE_API } from '../../middleware/api';
import { orgSchema } from '../../schemas';
import { getCurrentOrg } from 'js/reducers/session';

export const fetchAllOrgs = (id) => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_ALL_ORGS_REQUEST,
        actionTypes.GET_ALL_ORGS_SUCCESS,
        actionTypes.GET_ALL_ORGS_FAILURE,
      ],
      endpoint: `/orgs`,
      schema: [orgSchema],
      requestMethod: GET,
    },
  });
};

export const fetchCurrentOrg = () => (dispatch, getState) => {
  const state = getState();

  const org = getCurrentOrg(state);
  return dispatch(loadOrg(org.id));
};

export const loadOrg = (id) => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_ORG_REQUEST,
        actionTypes.GET_ORG_SUCCESS,
        actionTypes.GET_ORG_FAILURE,
      ],
      endpoint: `/orgs/${id}`,
      schema: orgSchema,
      requestMethod: GET,
    },
  });
};

export const fetchOrgMembers = (id) => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_ORG_MEMBERS_REQUEST,
        actionTypes.GET_ORG_MEMBERS_SUCCESS,
        actionTypes.GET_ORG_MEMBERS_FAILURE,
      ],
      endpoint: `/orgs/${id}/members`,
      schema: null,
      requestMethod: GET,
      requestInfo: {
        id,
      },
    },
  });
};

export const updateOrgInfo =
  (id, newInfo = {}) =>
  (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.UPDATE_ORG_INFO_REQUEST,
          actionTypes.UPDATE_ORG_INFO_SUCCESS,
          actionTypes.UPDATE_ORG_INFO_FAILURE,
        ],
        endpoint: `/orgs/${id}`,
        schema: orgSchema,
        requestMethod: PUT,
        payload: newInfo,
      },
    });
  };

export const updateOrgMember = (id, userInfo) => (dispatch) => {
  const members = Array.isArray(userInfo) ? userInfo : [userInfo];
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.UPDATE_ORG_MEMBER_REQUEST,
        actionTypes.UPDATE_ORG_MEMBER_SUCCESS,
        actionTypes.UPDATE_ORG_MEMBER_FAILURE,
      ],
      endpoint: `/orgs/${id}/members`,
      schema: null,
      requestMethod: PUT,
      payload: {
        members,
      },
      requestInfo: {
        id,
      },
    },
  }).then((response) => {
    const { result } = response;
    const { access_role, access_role_expiration_seconds, ...info } = userInfo;
    const member = find(result, { email: info.email });

    if (member) {
      return dispatch(updateUserInfo(member.id, info));
    }
  });
};

export const startEditOrg = (key, value) => ({
  type: actionTypes.START_EDIT_ORG,
});

export const cancelEditOrg = (key, value) => ({
  type: actionTypes.CANCEL_EDIT_ORG,
});

export const updateEditOrg = (key, value) => ({
  type: actionTypes.UPDATE_EDIT_ORG,
  key,
  value,
});

export const fetchOrgCustodians = (orgId) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_ORG_CUSTODIANS_REQUEST,
        actionTypes.GET_ORG_CUSTODIANS_SUCCESS,
        actionTypes.GET_ORG_CUSTODIANS_FAILURE,
      ],
      endpoint: `/orgs/${orgId}/custodians`,
      schema: null,
      requestMethod: GET,
      requestInfo: {
        orgId,
      },
    },
  });
};

export const addOrgCustodian = (orgId, userId) => (dispatch) => {
  const payload = {
    custodians: [{ id: userId }],
  };

  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.ADD_ORG_CUSTODIAN_REQUEST,
        actionTypes.ADD_ORG_CUSTODIAN_SUCCESS,
        actionTypes.ADD_ORG_CUSTODIAN_FAILURE,
      ],
      endpoint: `/orgs/${orgId}/custodians`,
      schema: null,
      requestMethod: PUT,
      payload,
      requestInfo: {
        orgId,
        userId,
      },
    },
  });
};

export const deleteOrgCustodian = (orgId, userId) => (dispatch) => {
  const payload = {
    custodians: [{ id: userId }],
  };

  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.DELETE_ORG_CUSTODIAN_REQUEST,
        actionTypes.DELETE_ORG_CUSTODIAN_SUCCESS,
        actionTypes.DELETE_ORG_CUSTODIAN_FAILURE,
      ],
      endpoint: `/orgs/${orgId}/custodians`,
      schema: null,
      requestMethod: DELETE,
      payload,
      requestInfo: {
        orgId,
        userId,
      },
    },
  });
};
